import react, { useContext, useEffect, useReducer, useMemo } from 'react'
import ColorButton from '../../Buttons/ColorButton'
import Table from '../../Table'
import { lockedReducer } from '../../Utils/reducers'
import { externalComponent } from '../../AppRoutes'
import { api } from '../../../services/api'
import toast from 'react-hot-toast'
import { ThemeProvider, useTheme } from '@mui/material/styles';
import { customTheme } from '../../theme/textfieldTheme'
import { TextField } from '@mui/material'
import { PercentFormatInputFive } from '../../Utils/PercentInputDefault'
import  SaveIcon from '@mui/icons-material/Save'
import  DeleteIcon  from '@mui/icons-material/Delete'
import {Box, Tooltip, IconButton,} from '@mui/material'

let timeout = 0
const timeoutTime = 50

const submit = async (row, setLoader) => {
    setLoader(true)
    let res = null
    if (row.create)
        res = await api.post('pendencias/', row)
    else
        res = await api.patch(`pendencias/${row.id}/`, row)
    if ([200, 201].includes(res.status)) {
        toast.success('Dados salvos com sucesso')
    } else {
        toast.error('Erro: Dados não foram salvos')
    }
    setLoader(false)
}

const deleteData = async (row, setState, setLoader) => {
    setLoader(true)
    let res = null
    if (row.create)
        ;
    else
        res = await api.delete(`pendencias/${row.id}/`)
    if (res.status === 204)
        toast.success('Dados removidos com sucesso')
    else
        toast.error('Erro: Dados não foram removidos')
    setLoader(false)
}

const changeData = (props, rows, newvalue, setState, extra = {}) => {
    clearTimeout(timeout)
    const row = rows.find(row => row.id === props.row.id)
    const value = { id: props.row.id, [props.field]: newvalue, edit: true, ...extra }
    Object.assign(row, value)
    props.api.updateRows([value])
    timeout = setTimeout(() => {
        setState({ products_rows: [...rows] })
    }, timeoutTime)
}

const getcolumns = (rows, setState, setLoader) => {
    const columns = []
    columns.push({ field: 'id', headerName: 'Código', flex: 1, renderCell: ({ row }) => row.create ? '' : row.id })
    columns.push({
        field: 'pendencia', headerName: 'Pendência', width: 300
        // , renderCell: (props) => (
        //     <TextField
        //         fullWidth
        //         value={props.value}
        //         onChange={({ target }) => { changeData(props, rows, target.value, setState) }}
        //     />
        // )
    })
    columns.push({
        field: 'descricao', headerName: 'Descrição', width: 600
        // , renderCell: (props) => (
        //     <TextField
        //         fullWidth
        //         value={props.value}
        //         onChange={({ target }) => { changeData(props, rows, target.value, setState) }}
        //     />
        // )
    })
    // columns.push({
    //     field: 'action', headerName: 'Ações', width: 200, renderCell: ({ row }) => (
    //         <Box>
    //             {row.edit &&
    //                 <Tooltip title='Salvar pendência'><IconButton
    //                     onClick={() => {
    //                         submit(row, setLoader)
    //                     }}
    //                 ><SaveIcon />
    //                 </IconButton>
    //                 </Tooltip>}
    //             <Tooltip title='Remover pendência'><IconButton
    //                 onClick={() => {
    //                     deleteData(row, setLoader)
    //                 }}
    //             ><DeleteIcon />
    //             </IconButton>
    //             </Tooltip>
    //         </Box>
    //     )
    // })
    return columns
}

const initialize = async (setState, setLoader) => {
    setLoader(true)
    const res = await api.get('pendencias/')
    if (res.status === 200)
        setState({ rows: res.data, ready: true })
    else
        toast.error('Falha ao recuperar as condições de pagamento')
    setLoader(false)
}

const Pending = () => {

    const { setLoader } = useContext(externalComponent)

    const [state, setState] = useReducer(lockedReducer, {
        loading: false,
        rows: [],
        ready: false,
        editRow: null
    })

    useEffect(() => {
        initialize(setState, setLoader)
    }, [])

    const outerTheme = useTheme()

    const setColumns = useMemo(() => getcolumns(state.rows, setState, setLoader), [state.rows])

    return (
        <>
                {state.ready &&
                    <Table
                        disableRowSelectionOnClick
                        paginationMode='client'
                        className='contabil-grid'
                        rows={state.rows}
                        columns={setColumns}
                        pagination={false}
                        toolbar
                        slots={{
                            returnComponent: () => window.backtobase(),
                            //addComponent: () => setState({ rows: [...state.rows, { id: Math.random(), create: true }] }),
                            filterComponent: true,
                            columnComponent: true
                        }}
                        density='compact'
                        rowHeight={30}
                    />}
        </>
    )
}

export default Pending